module.exports = __webpack_public_path__ + "img/hover-iocn47.2e9b4e94.png";